import React from 'react';
import { createPortal } from 'react-dom';
import classnames from 'classnames';
import './index.scss';

function WithModal(WrappedComponent) {
  return class WithModal extends React.Component {
    state = {
      show: false,
      animated: false,
    }

    constructor(props) {
      super(props);
    }

    componentDidMount(){
      this.setState({show: this.props.visible});
    }
    componentWillReceiveProps(nextProps) {
      if (this.props.visible !== nextProps.visible) {
        this.setState({
          show: nextProps.visible,
        });
      }
    }

    /**
     * 关闭事件
     */
    onClose = () => {
      const onClose = this.props.onClose;
      (typeof onClose === 'function') && onClose();
    }

    render() {
      const { show, animated } = this.state;
      const { closeBtn, onClose, ...rest } = this.props;
      if (show) {
        // 解决滚动穿透，先记录下当前滚动距离，设置body100%不可滚定，弹层消失后再手动滚动到原来位置
        let { document } = window;
        this.node = document.createElement('div');
        this.node.className = 'modal';
        document.body.appendChild(this.node);
        this.scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        document.body.style.cssText = `overflow: hidden; height: 100%; width: 100%; position: fixed; top:-${this.scrollTop}px`;
        // modal挂载到body下
        return createPortal(
          <React.Fragment>
            <div className={classnames('modal-mask', { 'fade-in': animated })}></div>
            <div className="modal-wrap">
              <div className="modal-wrap-dialog">
                <WrappedComponent onClose={onClose} {...rest}/>
                {closeBtn && <a className="close-btn" onClick={this.onClose}></a>}
              </div>
            </div>
          </React.Fragment>,
          this.node
        );
      } else {
        if (this.node) {
          window.document.body.removeChild(this.node);
          // 滚动条归位
          document.body.style.cssText = null;
          window.scrollTo(0, this.scrollTop);
          // 释放dom引用
          this.node = null;
        }
        return null;
      }
    }
  };
}



export default WithModal;